import * as React from 'react';
import { RouteComponentProps } from 'react-router';

export class PermissionFailed extends React.Component<RouteComponentProps<{}>, {}> {
    constructor(props: any) {
        super(props);
    }

    
    public render() {
        return <div>
            <h2 className="error">You do not have permission to view this page!</h2>
        </div>;

    }

}